import type * as React from 'react';

function PremiumTrophy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="100%"
      preserveAspectRatio="xMinYMid"
      viewBox="0 0 27 24"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="white" height="2.5" width="2.5" x="6.2002" y="2.5" />
      <path d="M6.5 6H9.5V8.5L10.5 14.5C10.5 14.5 8.30916 12.6081 7.5 11C6.60496 9.2212 6.5 6 6.5 6Z" fill="white" />
      <path
        d="M8.5 21.5C8.5 21.5 10.246 19.6461 11.7271 19.4373C12.2245 19.3672 13 19.5 13 19.5L11 21.5L8.5 21.5Z"
        fill="white"
      />
      <path
        d="M25.5796 4.4527C25.5796 3.99441 25.2045 3.62349 24.7424 3.62349H21.3892V3.10187C21.7282 2.99566 21.9748 2.68516 21.9748 2.31456C21.9748 1.85627 21.6 1.48535 21.1377 1.48535H6.19588C5.73286 1.48535 5.3587 1.85659 5.3587 2.31456C5.3587 2.68515 5.60497 2.99566 5.94502 3.10187V3.62349H2.37592C1.9129 3.62349 1.53809 3.99473 1.53809 4.4527C1.53809 10.4763 6.08072 15.4673 11.9509 16.248V16.25C11.9509 17.4751 11.4639 18.6772 10.493 19.283C9.53482 19.8803 8.56413 20.4899 7.83648 21.4049H7.74008C7.27738 21.4049 6.90289 21.7761 6.90289 22.2341C6.90289 22.6914 7.2777 23.0633 7.74008 23.0633H19.5363C19.9984 23.0633 20.3735 22.6914 20.3735 22.2341C20.3735 21.7758 19.9984 21.4049 19.5363 21.4049H19.3714C18.6437 20.4899 17.6737 19.882 16.7159 19.283C15.7459 18.6782 15.2573 17.4748 15.2573 16.25C15.2573 16.2454 15.2583 16.2406 15.2583 16.2373C21.0854 15.4169 25.5796 10.4464 25.5796 4.4527ZM21.4095 5.35917C21.4095 5.33222 21.3996 5.3085 21.394 5.2822H23.8722C23.6102 8.49444 21.8447 11.3932 19.2754 13.1656C20.6169 11.2103 21.4095 8.49675 21.4095 5.35917ZM6.90757 3.01931H8.5688V4.654H6.90757V3.01931ZM3.24604 5.28251H5.93924C5.93465 5.30849 5.92415 5.3322 5.92415 5.35949C5.92415 8.60058 6.7469 11.3906 8.13071 13.3589C5.40603 11.6089 3.51694 8.61399 3.24604 5.28251ZM8.26055 11.7872C7.44337 10.1268 7.00361 8.33977 6.92033 6.06493H8.56914C8.56914 9.19336 9.24924 11.9606 10.4848 14.3814C9.60144 13.8273 8.78748 12.858 8.26055 11.7872ZM11.1325 21.2444H9.13444C10.2189 20.1892 11.6086 19.5736 13.1262 19.4658C12.3507 19.9257 11.6732 20.5305 11.1325 21.2444Z"
        fill="url(#paint0_linear_2099_33929)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2099_33929"
          x1="2"
          x2="22.5"
          y1="1.99963"
          y2="19.4996"
        >
          <stop stopColor="#F5E01F" />
          <stop offset="1" stopColor="#FF8A00" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PremiumTrophy;
